import { Grid } from '@mui/material';
import React from 'react';
import { TFunction } from 'i18next';
import { TABLE_COLUMNS_IDS } from './tableColumns';
import { ISubscriptionPlan } from '../../../../types/interfaces/subscription-plan';
import EditActionButton from '../../../../components/designe/ActionButtons/EditActionButton';
import DeleteActionButton from '../../../../components/designe/ActionButtons/DeleteActionButton';

export function getCellReducers(
  t: TFunction,
  classes: any,
  { canDelete, canEdit },
  onEdit: (changeRequest: ISubscriptionPlan) => void,
  onDelete: (changeRequest: ISubscriptionPlan) => void,
) {
  return [
    {
      id: TABLE_COLUMNS_IDS.SCOPE,
      cellReducer: (plan: ISubscriptionPlan) => {
        return (
          <div className={classes.scope}>
            {t(`superAdminDashboard.scope_${plan.scope}`)}
          </div>
        );
      },
    },
    {
      id: TABLE_COLUMNS_IDS.PERIOD,
      cellReducer: (plan: ISubscriptionPlan) => {
        return (
          <div className={classes.period}>
            {t(`superAdminDashboard.period_${plan.period}`)}
          </div>
        );
      },
    },
    {
      id: TABLE_COLUMNS_IDS.STRIPE_PLAN_ID,
      cellReducer: (plan: ISubscriptionPlan) => {
        return <div className={classes.stripePlanId}>{plan.stripePlanId}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.PRICE,
      cellReducer: (plan: ISubscriptionPlan) => {
        return <div className={classes.price}>{plan.price}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.ORDER_NUMBER,
      cellReducer: (plan: ISubscriptionPlan) => {
        return <div className={classes.orderNumber}>{plan.orderNumber}</div>;
      },
    },
    !canEdit && !canDelete
      ? null
      : {
          id: TABLE_COLUMNS_IDS.ACTIONS,
          cellReducer: (plan: ISubscriptionPlan) => {
            return (
              <div className={classes.actions}>
                <Grid
                  className={classes.tdDefault}
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  wrap="nowrap">
                  <Grid
                    container
                    justifyContent="flex-end"
                    alignItems="center"
                    gap={1}
                    wrap="nowrap">
                    {canEdit && (
                      <EditActionButton
                        onClick={() => {
                          onEdit(plan);
                        }}></EditActionButton>
                    )}

                    {canDelete && (
                      <DeleteActionButton
                        onClick={() => {
                          onDelete(plan);
                        }}></DeleteActionButton>
                    )}
                  </Grid>
                </Grid>
              </div>
            );
          },
        },
  ].filter(Boolean);
}
